var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){$event.preventDefault();return _vm.changeViewer($event)}}},[_c('div',{class:[_vm.$style.iconStyle]},[_c('changeViewerIcon',{class:[_vm.$style.buttonIconPosition, _vm.$style.iconImageStyle]})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }